import { TeamMemberInitialsAvatar } from "@/components/ui/TeamMemberInitialsAvatar";

interface LibraryAssigneeCellProps {
  assignee: {
    id: string;
    first_name: string;
    last_name: string;
  } | null;
}

export function LibraryAssigneeCell({ assignee }: LibraryAssigneeCellProps) {
  if (!assignee) {
    return <span className="text-neutral-400">—</span>;
  }

  return (
    <span className="inline-flex min-w-0 items-center gap-2">
      <TeamMemberInitialsAvatar
        id={assignee.id}
        firstName={assignee.first_name}
        lastName={assignee.last_name}
      />
      <span className="min-w-0 text-xs leading-tight text-neutral-600">
        <span className="block truncate">{assignee.first_name}</span>
        <span className="block truncate">{assignee.last_name}</span>
      </span>
    </span>
  );
}
